var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { staticClass: "linha-2" },
    [
      _c(
        "v-col",
        { staticClass: "coluna", attrs: { sm: "12", md: "2", xs: "12" } },
        [
          _c(
            "v-col",
            { staticClass: "coluna", attrs: { sm: "12", md: "10", xs: "12" } },
            [_c("span", [_vm._v(" Estretégia")])]
          ),
          _c(
            "v-col",
            { staticClass: "coluna", attrs: { sm: "12", md: "2", xs: "12" } },
            [_c("span", [_vm._v(" Part.")])]
          )
        ],
        1
      ),
      _c(
        "v-col",
        { staticClass: "coluna", attrs: { sm: "12", md: "1", xs: "12" } },
        [
          _c("div", { staticClass: "descricao" }, [
            _c("span", [_vm._v(" Saldo Bruto ")])
          ])
        ]
      ),
      _c(
        "v-col",
        {
          staticClass: "coluna coluna-composta",
          attrs: { sm: "12", md: "3", xs: "12" }
        },
        [
          _c("div", { staticClass: "descricao" }, [
            _c("span", [_vm._v(" Resultado " + _vm._s(_vm.timeLabel) + " ")])
          ]),
          _c(
            "div",
            { staticClass: "colunas" },
            [
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { sm: "12", md: "3", xs: "12" } }, [
                    _c("div", { staticClass: "mes" }, [
                      _c("span", [_vm._v(_vm._s(_vm.monthLabel))])
                    ])
                  ]),
                  _c("v-col", { attrs: { sm: "12", md: "3", xs: "12" } }, [
                    _c("div", [
                      _c("span", [_vm._v("Dif. " + _vm._s(_vm.indice))])
                    ])
                  ]),
                  _c("v-col", { attrs: { sm: "12", md: "6", xs: "12" } }, [
                    _c("div", [_c("span", [_vm._v("R$")])])
                  ])
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "v-col",
        {
          staticClass: "coluna coluna-composta",
          attrs: { sm: "12", md: "3", xs: "12" }
        },
        [
          _c(
            "div",
            { staticClass: "colunas" },
            [
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { sm: "12", md: "3", xs: "12" } }, [
                    _c("div", { staticClass: "meses-12" }, [
                      _c("span", [_vm._v("12 meses")])
                    ])
                  ]),
                  _c("v-col", { attrs: { sm: "12", md: "3", xs: "12" } }, [
                    _c("div", [
                      _c("span", [_vm._v("Dif. " + _vm._s(_vm.indice))])
                    ])
                  ]),
                  _c("v-col", { attrs: { sm: "12", md: "6", xs: "12" } }, [
                    _c("div", [_c("span", [_vm._v("R$")])])
                  ])
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "v-col",
        {
          staticClass: "coluna coluna-composta",
          attrs: { sm: "12", md: "3", xs: "12" }
        },
        [
          _c(
            "div",
            { staticClass: "colunas" },
            [
              _c(
                "v-row",
                [
                  _c("v-col", { attrs: { sm: "12", md: "3", xs: "12" } }, [
                    _c("div", { staticClass: "inicio" }, [
                      _c("span", [_vm._v("Desde o início")])
                    ])
                  ]),
                  _c("v-col", { attrs: { sm: "12", md: "3", xs: "12" } }, [
                    _c("div", [
                      _c("span", [_vm._v("Dif. " + _vm._s(_vm.indice))])
                    ])
                  ]),
                  _c("v-col", { attrs: { sm: "12", md: "6", xs: "12" } }, [
                    _c("div", [_c("span", [_vm._v("R$")])])
                  ])
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }